import React, { Component } from "react";
import { connect } from "react-redux";
import BaseSelectField, { getOptionValue, getValue } from "../../../Base/ui/inputs/SelectField";
import updateAssociationName from "../helpers/update_association_name";

class SelectField extends Component {
  handleChange = (resource, options) => {
    if (this.props.multiselect) {
      const values = options ? options.map(option => option.value) : [];
      this.props.handleChange(this.props.name, values, resource);
    } else {
      this.props.handleChange(this.props.name, options ? options.value : null, resource);
    }
  }

  handleCreateOption = (inputValue) => {
    const { options = [], multiselect, resource, name, value } = this.props;
    const newOption = { label: inputValue, value: inputValue };

    if (multiselect) {
      const currentValues = Array.isArray(value) ? value : [];
      const newValues = [...currentValues, inputValue];
      this.props.handleChange(name, newValues, resource);
    } else {
      this.props.handleChange(name, inputValue, resource);
    }
  }

  render() {
    const { resource, name, label, col, action, optionValue, options=[], value, multiselect } = this.props;
    return(
      <BaseSelectField 
        value={value}
        optionValue={optionValue}
        options={options}
        onChange={this.handleChange.bind(this, resource)}
        onCreateOption={this.handleCreateOption}
        resource={resource}
        name={name}
        label={label}
        col={col}
        action={action}
        isMulti={multiselect}
        creatable={true}
        {...this.props} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { resource = "affiliateMemberDetail", name, options } = ownProps;
  const stateValue = state[resource] === null ? '' : state[resource][name];
  return {
    action: ownProps.action || state.ui.action,
    value: stateValue,
    optionValue: getOptionValue(state, ownProps),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleChange: (name, value, resource) => {
      dispatch({
        type: `UPDATE_${updateAssociationName(resource)}`,
        payload: {name, value}
      });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectField);
